import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  QueryGetFlexibleBenefitsListResponse,
  ListSalaryComponentsQueryVariables,
  ListSalaryComponentsInput,
} from '../types';

const getFlexibleBenefitsQuery = gql`
  query ListFlexibleBenefitsComponents($input: ListSalaryComponentsInput!) {
    payrollListFlexibleBenefitsComponents(input: $input) {
      source
      data {
        id
        name
        display_name
        description
        category
        is_active
        settings {
          flexible_settings {
            salary_settings {
              show_in_gross_salary
              non_cash_benefit
            }
            declaration_settings {
              declaration_enabled
            }
            benefit_amount_settings {
              unit
              list_of_options_amount {
                amounts
                default_option_index
                allow_multiple
                amount_labels
              }
              fixed_amount {
                amount
                description
              }
              range_amount {
                max
                min
                step
              }
            }
            declaration_settings {
              declaration_enabled
            }
            tax_behaviour {
              tax_exempt_in_old_regime
              tax_exempt_in_new_regime
              tax_exemption_section
              tax_deduction_behaviour
            }
          }
        }
        component_type
        component_space
        tenant_id
        created_at
        updated_at
        response_precision
      }
      total_count
      limit
      offset
      code
      success
      message
    }
  }
`;

export const getFlexibleBenefitsList = (input: ListSalaryComponentsInput) => {
  return graphQLApi<QueryGetFlexibleBenefitsListResponse, ListSalaryComponentsQueryVariables>({
    query: getFlexibleBenefitsQuery,
    queryVariables: { input },
  });
};
